/* KPMI vehicle finder. Data: the store's own /collections.json at runtime; only existing,
   published collections with products and a model year in the title are offered. */
  (function () {
    if (customElements.get('kpmi-vehicle-finder')) return;
    var CACHE_KEY = 'kpmiFinderCollections_v2';
    var HIDE_RE = /buell/i;
    var MARK_STRIP_RE = /\b(Polaris|BRP|Sea-?Doo|Rotax|Can[- ]?Am|Husqvarna|Norton|BSA|Indian|Arctic Cat|GAS ?GAS|Moto Guzzi|Mitsubishi|Porsche)\s*®/gi;
    function displayTitle(t) { return t.replace(MARK_STRIP_RE, '$1'); }
    var ALIASES = { 'HD': 'Harley-Davidson (HD)', 'Can Am': 'Can-Am', 'Seadoo': 'Sea-Doo' };

    function cleanBrand(title) {
      var m = title.split(/[®™]/)[0].replace(/\s+/g, ' ').trim();
      if (m === title.trim()) m = title.trim().split(' ')[0];
      if (m.length > 4 && m === m.toUpperCase()) m = m.charAt(0) + m.slice(1).toLowerCase();
      return ALIASES[m] || m;
    }
    function yearSpans(title) {
      var spans = [], used = [], m;
      var re = /((?:19|20)\d{2})\s*[-–]\s*['‘’]?(\d{4}|\d{2})(?!\d)/g;
      while ((m = re.exec(title))) {
        var a = +m[1], b = m[2];
        var end = b.length === 4 ? +b : Math.floor(a / 100) * 100 + +b;
        if (end < a) end += 100;
        spans.push([a, end]); used.push([m.index, m.index + m[0].length]);
      }
      var pre = /pre[-\s]?((?:19|20)\d{2})/i.exec(title);
      if (pre) { spans.push([1900, +pre[1] - 1]); used.push([pre.index, pre.index + pre[0].length]); }
      var re2 = /(^|[^\d])((?:19|20)\d{2})(?!\d)/g;
      while ((m = re2.exec(title))) {
        var pos = m.index + m[1].length;
        var inside = used.some(function (u) { return pos >= u[0] && pos < u[1]; });
        if (!inside) spans.push([+m[2], +m[2]]);
      }
      return spans;
    }
    function hasYear(title) { return /(^|[^\d])(19|20)\d{2}(?!\d)/.test(title); }

    function loadCollections() {
      try { var c = sessionStorage.getItem(CACHE_KEY); if (c) return Promise.resolve(JSON.parse(c)); } catch (e) {}
      var all = [];
      function page(p) {
        return fetch('/collections.json?limit=250&page=' + p, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function (j) {
            var list = j.collections || [];
            list.forEach(function (c) {
              if (c.products_count > 0 && hasYear(c.title) && !HIDE_RE.test(c.title) && !HIDE_RE.test(c.handle)) all.push({ t: c.title, h: c.handle });
            });
            if (list.length === 250 && p < 10) return page(p + 1);
            return all;
          });
      }
      return page(1).then(function (res) {
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(res)); } catch (e) {}
        return res;
      });
    }

    class KpmiVehicleFinder extends HTMLElement {
      connectedCallback() {
        this.make = this.querySelector('[data-finder-make]');
        this.year = this.querySelector('[data-finder-year]');
        this.vehicle = this.querySelector('[data-finder-vehicle]');
        this.go = this.querySelector('[data-finder-go]');
        this.status = this.querySelector('[data-finder-status]');
        var self = this;
        var form = this.querySelector('form');
        if (form) form.addEventListener('submit', function (e) { e.preventDefault(); if (self.vehicle.value) window.location.href = self.vehicle.value; });
        loadCollections().then(function (list) { self.init(list); }).catch(function () {
          self.make.replaceChildren(new Option('Unavailable', ''));
          self.status.textContent = 'The vehicle finder could not load. ';
        });
      }
      init(list) {
        var self = this, brands = {};
        this.items = list.filter(function (c) { return !HIDE_RE.test(c.t) && !HIDE_RE.test(c.h); }).map(function (c) {
          var b = cleanBrand(c.t);
          brands[b] = (brands[b] || 0) + 1;
          return { title: displayTitle(c.t), url: '/collections/' + encodeURIComponent(c.h), brand: b, spans: yearSpans(c.t) };
        });
        var names = Object.keys(brands).sort(function (a, b) { return a.localeCompare(b); });
        this.make.replaceChildren.apply(this.make, [new Option('Select make', '')].concat(names.map(function (n) { return new Option(n, n); })));
        this.make.disabled = false;
        this.make.addEventListener('change', function () { self.fillYears(); self.fillVehicles(); });
        this.year.addEventListener('change', function () { self.fillVehicles(); });
        this.vehicle.addEventListener('change', function () { self.go.disabled = !self.vehicle.value; });
        this.go.addEventListener('click', function () { if (self.vehicle.value) window.location.href = self.vehicle.value; });
      }
      brandItems() { var b = this.make.value; return this.items.filter(function (i) { return i.brand === b; }); }
      fillYears() {
        var years = {}, max = +this.getAttribute('data-max-year') || 2030;
        this.brandItems().forEach(function (i) {
          i.spans.forEach(function (s) { for (var y = Math.max(s[0], 1900); y <= Math.min(s[1], max); y++) years[y] = 1; });
        });
        var ys = Object.keys(years).map(Number).sort(function (a, b) { return b - a; });
        this.year.replaceChildren.apply(this.year, [new Option('Any year', '')].concat(ys.map(function (y) { return new Option(String(y), String(y)); })));
        this.year.disabled = !this.make.value || ys.length === 0;
      }
      fillVehicles() {
        var y = +this.year.value, list = this.brandItems();
        if (y) list = list.filter(function (i) {
          return i.spans.length === 0 || i.spans.some(function (s) { return y >= s[0] && y <= s[1]; });
        });
        list.sort(function (a, b) { return a.title.localeCompare(b.title); });
        var first = this.make.value ? 'Select model (' + list.length + ')' : 'Select make first';
        this.vehicle.replaceChildren.apply(this.vehicle, [new Option(first, '')].concat(list.map(function (i) { return new Option(i.title, i.url); })));
        this.vehicle.disabled = !this.make.value || list.length === 0;
        this.go.disabled = true;
      }
    }
    customElements.define('kpmi-vehicle-finder', KpmiVehicleFinder);
  })();

/* "Shop by Vehicle" dialog (header button on every page) */
(function () {
  function dlg() { return document.getElementById('KpmiSbvDialog'); }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-kpmi-sbv-open]');
    if (open) {
      var d = dlg();
      if (d && typeof d.showModal === 'function') {
        e.preventDefault();
        var cd = document.querySelector('cart-drawer.active');
        if (cd && cd.close) cd.close();
        d.showModal();
        var first = d.querySelector('select:not([disabled])');
        if (first) first.focus();
      }
      return;
    }
    if (e.target.closest('[data-kpmi-sbv-close]')) { var d2 = dlg(); if (d2) d2.close(); return; }
    var d3 = dlg();
    if (d3 && e.target === d3) d3.close();
  });
})();

